import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import PhieuTangGiamNhanSuService from "services/hrm/PhieuTangGiamNhanSuService";
const unwrapResponseData = (response) => {
  const body = response?.data;
  return body?.data?.data ?? body?.data ?? body;
};
export const searchGridPhieuTangGiamNhanSu = createAsyncThunk(
  "phieuTangGiamNhanSu/search-grid",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PhieuTangGiamNhanSuService.searchGrid(payload);
      const responseData = unwrapResponseData(response);
      if (onSuccess) onSuccess(responseData);
      return responseData;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

export const getPhieuTangGiamNhanSuCounts = createAsyncThunk(
  "phieuTangGiamNhanSu/counts",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PhieuTangGiamNhanSuService.counts(payload);
      const responseData = unwrapResponseData(response);
      if (onSuccess) onSuccess(responseData);
      return responseData;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

export const getPhieuTangGiamNhanSuById = createAsyncThunk(
  "phieuTangGiamNhanSu/getById",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await PhieuTangGiamNhanSuService.getById(id);
      const responseData = unwrapResponseData(response);
      if (onSuccess) onSuccess(responseData);
      return responseData;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

export const createPhieuTangGiamNhanSu = createAsyncThunk(
  "phieuTangGiamNhanSu/create",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PhieuTangGiamNhanSuService.create(payload);
      const responseData = unwrapResponseData(response);
      if (onSuccess) onSuccess(responseData);
      return responseData;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

export const updatePhieuTangGiamNhanSu = createAsyncThunk(
  "phieuTangGiamNhanSu/update",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PhieuTangGiamNhanSuService.update(payload);
      const responseData = unwrapResponseData(response);
      if (onSuccess) onSuccess(responseData);
      return responseData;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

export const deletePhieuTangGiamNhanSu = createAsyncThunk(
  "phieuTangGiamNhanSu/delete",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await PhieuTangGiamNhanSuService.delete(id);
      const responseData = unwrapResponseData(response);
      if (onSuccess) onSuccess(responseData);
      return responseData;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

export const exportPhieuTangGiamNhanSuExcel = createAsyncThunk(
  "phieuTangGiamNhanSu/export-excel",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, fileName = "PhieuTangGiamNhanSu.xlsx" } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      delete payload.fileName;

      const response = await PhieuTangGiamNhanSuService.exportExcel(payload);
      // Tạo URL từ blob và download file
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      if (onSuccess) onSuccess();
      return { success: true };
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);
export const getHistoryQuaTrinhHanhNghe = createAsyncThunk(
  "phieuTangGiamNhanSu/getHistoryQuaTrinhHanhNghe",
  async (data, { rejectWithValue }) => {
    try {
      const { employeeId } = data;
      const response = await PhieuTangGiamNhanSuService.getHistoryQuaTrinhHanhNghe(employeeId);
      const responseData = unwrapResponseData(response);
      return responseData;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  phieuTangGiamNhanSuList: [],
  phieuTangGiamNhanSuDetail: null,
  counts: {
    total: 0,
    pending: 0,
    completed: 0,
  },
};

const phieuTangGiamNhanSuSlice = createSlice({
  name: "phieuTangGiamNhanSu",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Search Grid
      .addCase(searchGridPhieuTangGiamNhanSu.pending, (state) => {
        state.loading = true;
        state.phieuTangGiamNhanSuList = [];
      })
      .addCase(searchGridPhieuTangGiamNhanSu.fulfilled, (state, action) => {
        state.loading = false;
        state.phieuTangGiamNhanSuList = action.payload;
      })
      .addCase(searchGridPhieuTangGiamNhanSu.rejected, (state) => {
        state.loading = false;
      })
      // Get Counts
      .addCase(getPhieuTangGiamNhanSuCounts.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPhieuTangGiamNhanSuCounts.fulfilled, (state, action) => {
        state.loading = false;
        state.counts = action.payload;
      })
      .addCase(getPhieuTangGiamNhanSuCounts.rejected, (state) => {
        state.loading = false;
      })
      // Get By Id
      .addCase(getPhieuTangGiamNhanSuById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPhieuTangGiamNhanSuById.fulfilled, (state, action) => {
        state.loading = false;
        state.phieuTangGiamNhanSuDetail = action.payload;
      })
      .addCase(getPhieuTangGiamNhanSuById.rejected, (state) => {
        state.loading = false;
      })
      // Create
      .addCase(createPhieuTangGiamNhanSu.pending, (state) => {
        state.loading = true;
      })
      .addCase(createPhieuTangGiamNhanSu.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createPhieuTangGiamNhanSu.rejected, (state) => {
        state.loading = false;
      })
      // Update
      .addCase(updatePhieuTangGiamNhanSu.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatePhieuTangGiamNhanSu.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updatePhieuTangGiamNhanSu.rejected, (state) => {
        state.loading = false;
      })
      // Delete
      .addCase(deletePhieuTangGiamNhanSu.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletePhieuTangGiamNhanSu.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deletePhieuTangGiamNhanSu.rejected, (state) => {
        state.loading = false;
      })
      //Excel
      .addCase(exportPhieuTangGiamNhanSuExcel.pending, (state) => {
        state.loading = true;
      })
      .addCase(exportPhieuTangGiamNhanSuExcel.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(exportPhieuTangGiamNhanSuExcel.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default phieuTangGiamNhanSuSlice.reducer;
